<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (tags.length > 0) {
<div style="margin-bottom: 10px;">
    Retrigger Message for below Id's :
  </div>
}
  
  @for (tag of tags; track $index; let i = $index) {
<div style="margin:0px 5px 5px 0px" class="btn-group btn-group-xs" role="group" aria-label="">
    <div class="btn btn-xs btn-default"><i class="fa fa-tag"></i></div>
    <div class="btn btn-default btn-xs btn-white">{{tag}}</div>
    <div class="btn btn-danger btn-xs" (click)="removeTag(i)"><i class="fa fa-times"></i></div>
  </div>
}
  
  @if (tags.length == 0) {
<div class="noIdBlock">
    No ID's selected.
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked || tags.length == 0"
          (click)="regenerateProcess()">
    @if (saveloader) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
